import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { AjaxCreationMethod, AjaxResponse } from 'rxjs/observable/dom/AjaxObservable';
import {
  AddMessageRequest,
  addMessageSuccess,
  addMessageFailure,
  AppAction,
} from '../actions';
import { ADD_MESSAGE_REQUEST } from '../constants';
import { AppState, AuthState, Messages, MessageCategory } from '../models';
import { getCannedMessageEndpoint } from '../configs';
import * as epicCommon from './epicCommon';
import * as errorUtil from '../utils/errorUtil';

const getNewMessageDisplayOrder = (messages: Messages) => {
  const displayOrders: number[] = messages.map(m => (m.displayOrder || 0));
  const max: number = Math.max(...displayOrders);
  return max + 1;
};

const getNewMessageDisplayOrderWithCategory = 
(messageCategories: MessageCategory[], categoryId: number) => {
  const messageCategory = messageCategories.find(mc => mc.id === categoryId);
  if (messageCategory 
    && messageCategory.messages 
    && messageCategory.messages.length >= 0) {
    return messageCategory.messages.length + 1;
  }
  return 0;
};

export const addMessage = (action$: ActionsObservable<AppAction>,
                           store: Store<AppState>,
                           ajax: AjaxCreationMethod): Observable<AppAction> => {

  return action$.ofType(ADD_MESSAGE_REQUEST)
    .mergeMap((addRequest: AddMessageRequest) => {
      const state: AuthState = store.getState().authState;
      const messageCategories = store.getState().messageState.messageCategories;
      const url = getCannedMessageEndpoint() + `canned-messages`;
      const categories = (addRequest.tags || []).map(t => ({ id: t, 
        displayOrder: getNewMessageDisplayOrderWithCategory(messageCategories, t) }));
      const requestBody = {
        categories,
        text: addRequest.message,
        expertId: state.expertId,
        displayOrder: getNewMessageDisplayOrder(store.getState().messageState.messages),
      };
      return ajax.post(url, requestBody, epicCommon.getHttpHeaders(state.authToken))
        .map((res: AjaxResponse) => addMessageSuccess(res.response))
        .catch((err) => { 
          errorUtil.throwErrorAsync(err);
          return Observable.of(addMessageFailure(epicCommon.extractMessage(err)));
        },
      );
    });
};





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/addMessage.ts